import { Component } from '@angular/core';
import { AuthService } from './services/auth.service';
import { ProgramInfoService } from './services/programInfo.service';
import { TerminalsPollService } from './services/terminals-poll.service';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    standalone: false
})
export class AppComponent {
  title = 'app';

  constructor(private terminalsPollService: TerminalsPollService, private authService: AuthService,
    public programInfoService: ProgramInfoService) {
  }

  get isLoggedIn(): boolean {
    return this.authService.isLoggedIn;
  }
}
